import type { RedirectStyle } from '../types';

import { directoryParamName, namespaceParamName } from '@/common/directories';
import { waitForWindowEvent } from './window-listener';
import { addSandboxAttributes, getIframeUrl } from '../common/iframe';

function getConsentUrl(
  interopHost: string,
  namespace: string,
  directoryName: string,
  landingPage?: string,
) {
  let url = `${interopHost}/consent?${directoryParamName}=${directoryName}&${namespaceParamName}=${namespace}`;
  if (landingPage) {
    url += `&interopUrl=${landingPage}`;
  }
  return url;
}

async function requestConsentInWindow(
  interopHost: string,
  namespace: string,
  directoryName: string,
) {
  const consentWindow = window.open(
    getConsentUrl(interopHost, namespace, directoryName),
  );
  if (!consentWindow) return false;

  const topic = await waitForWindowEvent('login', 'consent-denied');

  consentWindow.close();
  return topic === 'login';
}

async function redirectToRequestConsent(
  interopHost: string,
  namespace: string,
  directoryName: string,
) {
  window.location.href = getConsentUrl(
    interopHost,
    namespace,
    directoryName,
    window.location.href,
  );
  return false;
}

export async function requestConsent(
  interopHost: string,
  namespace: string,
  directoryName: string,
  consentRedirectStyle: RedirectStyle = 'sameWindow',
) {
  return consentRedirectStyle === 'newWindow'
    ? requestConsentInWindow(interopHost, namespace, directoryName)
    : redirectToRequestConsent(interopHost, namespace, directoryName);
}

export async function waitForStorageAccess() {
  const topic = await waitForWindowEvent(
    'storage-access-granted',
    'storage-access-denied',
  );
  return topic === 'storage-access-granted';
}

export function createStorageAccessIframe(interopHost: string, appId: string) {
  const iframe = document.createElement('iframe');
  addSandboxAttributes(iframe);
  iframe.src = getIframeUrl(
    interopHost,
    appId,
    'request-storage-access-iframe.bundle.js',
  );
  iframe.style.display = 'flex';
  iframe.style.border = 'none';
  iframe.width = '50px';
  iframe.height = '35px';
  return iframe;
}
